import pendingRemovalTimers from './pendingRemovalTimers';
import getRemoveItemFromCartEndpoint from './getRemoveItemFromCartEndpoint';
import { postApi } from 'middlewares/form';

function cleanupItemsPendingRemoval (store) {
  return new Promise((resolve, reject) => {
    const pendingRemovalIds = Object.keys(pendingRemovalTimers);
    if (!pendingRemovalIds.length) {
      return resolve();
    }

    // clear timeouts
    pendingRemovalIds.forEach(id => clearTimeout(pendingRemovalTimers[id].timer));

    postApi({
      endpoint: getRemoveItemFromCartEndpoint(store),
      payload: {
        id: pendingRemovalIds.join(','),
      },
    })
    .then(() => {
      // delete all cache
      pendingRemovalIds.forEach(id => delete pendingRemovalTimers[id]);
      return resolve();
    })
    .catch(() => reject());
  });
}

export default cleanupItemsPendingRemoval;



// WEBPACK FOOTER //
// ./src/cart/actions/helpers/cleanupItemsPendingRemoval.js